import { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

export const ExperimentContext = createContext({});

const ExperimentProvider = ({ children }: any) => {
    const experiments = {};
    return <ExperimentContext.Provider value={experiments}>{children}</ExperimentContext.Provider>;
};

export const useExperiments = () => useContext(ExperimentContext);

export default ExperimentProvider;

ExperimentProvider.propTypes = {
    children: PropTypes.node.isRequired
};
